<template>
  <div></div>
</template>

<script>

export default {
  
}
</script>

<style lang="scss">
.notion {
  max-width: 50rem;
  margin: 0 auto;
  padding: 2rem 1.5rem;

  &-page-cover {
    width: 100%;
  }

  &-page-icon-cover {
    display: none;
  }

  &-title {
    font-size: 2.2rem;
    font-weight: 500;
    line-height: 1.1;
    margin-bottom: 1rem;
  }

  .notion-asset-wrapper {
    div {
      padding-bottom: 0 !important; // Required, otherwise there will be whitespace with the height of the image below the image itself

      img {
        max-width: 100%;
      }
    }
  }
}
</style>
